import { useEffect } from 'react';

export const useSubmitFormOnEnter = ({
    element,
    onSubmit,
}: {
    element: HTMLElement | null;
    onSubmit: () => unknown;
}) => {
    useEffect(() => {
        const submitOnEnter = (e: KeyboardEvent) => {
            if (e.code === 'Enter') {
                onSubmit();
            }
        };
        if (element) {
            element.addEventListener('keydown', submitOnEnter);
            return () => {
                element.removeEventListener('keydown', submitOnEnter);
            };
        }
    }, [element, onSubmit]);
};
